import { memo } from 'react'
import { TableRow } from '@/components/ui/table'
import type { MatchCourses } from '@/types/courses/match-courses'
import type { DesiredEducationCourse } from '@/types/education/desired-education-course'
import { useTranscriptStatus } from '../../hooks/use-transcript-status'
import { EntrySerie } from '../entry-serie'
import { TranscriptTableCell } from '../transcript-table-cell'

interface TranscriptTableRowProps {
  course: DesiredEducationCourse
  equivalence?: MatchCourses
  selectedSerie?: string
  index: number
}

import { AnimatePresence, motion } from 'framer-motion'
import { cn } from '@/lib/utils'

export const TranscriptTableRow = memo(function TranscriptTrableRowMotion({
  course,
  equivalence,
  selectedSerie,
  index
}: TranscriptTableRowProps) {
  const {
    actions: { resolveEffectiveStatus }
  } = useTranscriptStatus()

  const status = resolveEffectiveStatus(
    equivalence?.equivalenceStatus?.id || ''
  )

  const contentKey = `${status}-${selectedSerie}`

  return (
    <TableRow
      className={cn(
        'group border bg-background relative',
        index === 0 ? '-mt-8' : ''
      )}
    >
      <TranscriptTableCell>{course.name}</TranscriptTableCell>
      <TranscriptTableCell>{course.workload}h</TranscriptTableCell>
      <TranscriptTableCell>
        {equivalence?.previousCourse?.finalNumericGrade || '--'}
      </TranscriptTableCell>
      <TranscriptTableCell>{course.period}</TranscriptTableCell>
      <TranscriptTableCell>
        <AnimatePresence mode="wait">
          <motion.div
            key={contentKey}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="flex items-center justify-between"
          >
            <span>{status}</span>
            <EntrySerie
              disciplineSerie={String(course.serie)}
              selectedSerie={selectedSerie || ''}
            />
          </motion.div>
        </AnimatePresence>
      </TranscriptTableCell>
    </TableRow>
  )
})
